module.exports = __webpack_public_path__ + "static/img/14000517.08d98b90.png";